import { styled } from '@/stitches.config';

import { Sizes } from '@common/types';

export const tabStyles = {};

export const TabStyled = styled('button', {
  fontFamily: 'TTNorms',
  cursor: 'pointer',
  display: 'inline',
  '&:focus-visible': {
    outline: '$borderWidths$2 solid $colors$primary',
    borderRadius: '$2',
  },

  variants: {
    size: {
      small: {
        $$tabBgColor: '$white',
        backgroundColor: '$$tabBgColor',
        color: '$textPrimary',
        fontWeight: '$regular',
        fontSize: '$normal',
        width: 'auto',
        border: '$0',
        py: '$2',
        px: '$0',
        borderRadius: '$0',
        marginRight: '$4',
        '&:hover': {
          backgroundColor: '$$tabBgColor',
        },
      },

      large: {
        border: 'none',
        backgroundColor: '$darkBlue800',
        color: '$darkBlue500',
        fontWeight: '$bold',
        fontSize: '$md',
        width: '278px',
        py: '$2',
        px: '$0',
        borderRadius: '$4 $4 0 0',
        marginRight: '$3',
        paddingTop: '$3',
      },
    },

    selected: {
      true: {},
    },
    disabled: {
      true: {},
    },
  },

  compoundVariants: [
    {
      css: {
        backgroundColor: '$white',
        boxSizing: 'border-box',
        borderBottom: '$borderWidths$1 solid $white',
        borderTop: '$borderWidths$4 solid $colors$primary',
        borderLeft: '$borderWidths$1 solid $colors$coolGray200',
        borderRight: '$borderWidths$1 solid $colors$coolGray200',
        color: '$darkBlue',
        marginBottom: '-1px',
        paddingTop: '$2',
      },
      selected: true,
      size: Sizes.LARGE,
    },
    {
      css: {
        borderBottom: '$borderWidths$3 solid $colors$primary',
        fontWeight: '$medium',
      },
      selected: true,
      size: Sizes.SMALL,
    },
    {
      css: {
        color: '$darkGray700',
        cursor: 'not-allowed',
      },
      disabled: true,
      size: Sizes.SMALL,
    },
  ],

  defaultVariants: {
    size: Sizes.SMALL,
  },
});
